import { useDispatch } from "react-redux";
import { User } from "types";
import { useNavigate } from "react-router";

import {
  setShowDSCreationWarning,
  setShowSignUpModal,
} from "redux/Modals/actions";
import { isOnPremUser } from "helpers/utility/utilities";

import {
  CREATE_NEW_DATASET,
  SIGNUP_ORIGIN,
} from "helpers/constants/amplitudeProperties";

import AddDatasetIcon from "assets/icons/AddDatasetIcon";
import styles from "./style.module.scss";
import { isAnonymousUser } from "redux/authReducer";
import { resetStore } from "redux/CreateDataset/actions";
import useCreateDataset from "hooks/useCreateDataset";

type AddDatasetCardTypes = {
  isContentLoading: boolean;
  user: User | null;
};

const AddDatasetCard = ({ isContentLoading, user }: AddDatasetCardTypes) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createNewDataset } = useCreateDataset();

  const handleClick = async () => {
    //check if user has not signed-in
    const datasetCreationEnabled = (process.env.REACT_APP_DATASET_CREATION_FROM_UI_ENABLED || "").trim().replace(/"/g, '');

    if (datasetCreationEnabled !== "true") {
      return;
    }

    // Only show on-prem warning if dataset creation from UI is NOT explicitly enabled
    if (isOnPremUser() && datasetCreationEnabled !== "true") {
      dispatch(setShowDSCreationWarning(true));
      return;
    }

    // Check authentication for non-onprem users only (or when auth is not disabled)
    if (
      !isOnPremUser() &&
      !process.env.REACT_APP_IS_AUTHENTICATION_DISABELED &&
      (user === null || isAnonymousUser())
    ) {
      dispatch(setShowSignUpModal(true));
      localStorage.setItem(SIGNUP_ORIGIN, CREATE_NEW_DATASET);
      return;
    }
    //open the new dataset creation flow
    dispatch(resetStore());
    const newDatasetId = await createNewDataset();

    if (newDatasetId) {
      navigate(`/dataset/${newDatasetId}/create`);
    }
    return;
  };

  return (
    <div
      className={isContentLoading ? "d-none" : styles.addDatasetWrapper}
      onClick={handleClick}
    >
      <div className={styles.addDatasetIcon}>
        <AddDatasetIcon />
      </div>
      <span className={styles.addDatasetText}>Add a new Dataset</span>
    </div>
  );
};

export default AddDatasetCard;
